<template>
  <div class="container-center">
    <!-- 公共头部 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- 教学中心 -->
    <div class="center-wrapper">
      <div class="menu">
        <table class="table-wrapper" style="border-collapse:separate; border-spacing:0px 40px;">
          <tr>
            <th>北京中心地址</th>
            <td>
              北京市海淀区学院南路12号-北京师范大学京师科技大厦A座13层</br>
              招生老师-仇老师:13269588320
              招生老师-徐老师:15313117183
            </td>
          </tr>
          <tr>
            <th>上海中心地址</th>
            <td>
              江苏省苏州市吴中区丰园路98号艺展中心文化产业园</br>
              招生老师-张老师:18012783327
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 公共版权 -->
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: "NewsDetails",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      selected: "1"
    };
  },
  methods: {},
  mounted() {
  }
};
</script>
<style scoped>
.center-wrapper {
  width: 95%;
  height: auto;
  margin: 0 auto;
}

.banner-info {
  width: 100%;
  height: 200px;
  background: url('../../assets/images/banner002.png');
  background-size: 100% 100%;
}

.menu {
  width: 95%;
  margin: 0 auto;
  padding-top: 30px;
  margin-bottom: 50px;
}

/*tab切换样式 */

.mint-navbar {
  width: 100%;
  height: 60px;
}

.mint-navbar .mint-tab-item {
  border: 2px solid #E58111;
  width: 348px;
  height: 60px;
  color: #E58111;
}

.mint-navbar .mint-tab-item.is-selected {
  background: #E58111;
  font-size: 24px;
  color: #fff;
}

>>> .mint-tab-item-label {
  font-size: 26px;
}

.table-wrapper {
  width: 100%;
}

th {
  width: 30%;
  min-height: 80px;
  text-align: center;
  vertical-align: middle;
  font-size: 30px;
  color: #343434;
}

td {
  width: 80%;
  min-height: 80px;
  border-left: 2px solid #E58111;
  font-size: 29px;
  padding-left: 50px;
  vertical-align: middle;
  color: #343434;
  line-height: 45px;
}

.par {
  width: 50%;
}

td img {
  /*width: 200px;*/
  /*height: 68px;*/
}

.t1 {
  width: 75px;
  height: 79px;
}

.t2 {
  width: 143px;
  height: 27px;
}

.t5 {
  width: 76px;
  height: 90px;
}

.t7 {
  width: 95px;
  height: 90px;
}

.t8 {
  width: 80px;
  height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/pages/admissions/centerPage.vue